import "./App.css";
import { createContext, useState } from "react";
import { ModalProvider, Modal_input } from "./ModalInput";
import { useContext } from "react";
import { ModalContext } from "./ModalInput";
import {ModalCongrats} from './ModalCongrats'

export const bookmarkContext = createContext();
export function Set({ children }) {
  var [bookmarktext, Setbookmarktext] = useState(false);
  var [text, Settext] = useState("Bookmark");
  var [fill, Setfill] = useState('#2F2F2F')
  var [backed, Setbacked] = useState(89914)
  var [backers, Setbackers] = useState(5007)
  return (
    <bookmarkContext.Provider
      value={{ bookmarktext, Setbookmarktext, text, Settext, fill, Setfill , backed, Setbacked,backers, Setbackers}}
    >
      {children}
    </bookmarkContext.Provider>
  );
}
var bookmark_styles = {
  paddingTop: 18,
  paddingBottom: 18,
  position: "relative",
  top: 50,
  left: 270,
  border: "none",
  fontFamily: "Commissioner, sans-serif",
  cursor: "pointer",
  width: 190,
  color: "hsl(0, 0%, 48%)",
  fontWeight: 700,
  borderRadius: 25,
  backgroundColor: "rgb(228, 228, 228)",
  fontSize: 16,
  paddingLeft: 30,
};

function App() {
  var {backers, Setbackers} = useContext(bookmarkContext)
  var { text, Settext } = useContext(bookmarkContext);
  var { bookmarktext, Setbookmarktext } = useContext(bookmarkContext);
  const { modal, setModal } = useContext(ModalContext);
  var {filling, Setfill} = useContext(ModalContext)
  var {backed, Setbacked} = useContext(bookmarkContext)
  var bookmark_icon_styles = {
    fill : '#000000'
  }
  const change_icon_styles = () => {
    bookmark_icon_styles = {
      fill : '#167974'
    }
  }
  const BookmarkShift = () => {
    bookmark_styles = {
      paddingTop: 18,
      paddingBottom: 18,
      position: "relative",
      top: 50,
      left: 270,
      border: "none",
      fontFamily: "Commissioner, sans-serif",
      cursor: "pointer",
      width: 190,
      color: "hsl(176, 74%, 28%)",
      fontWeight: 700,
      borderRadius: 25,
      backgroundColor: "hsl(192, 29%, 97%)",
      fontSize: 16,
      paddingLeft: 30,
    };
  };
  const resetBookmark = () => {
    bookmark_styles = {
      paddingTop: 18,
      paddingBottom: 18,
      position: "relative",
      top: 50,
      left: 270,
      border: "none",
      fontFamily: "Commissioner, sans-serif",
      cursor: "pointer",
      width: 190,
      color: "hsl(0, 0%, 48%)",
      fontWeight: 700,
      borderRadius: 25,
      backgroundColor: "rgb(228, 228, 228)",
      fontSize: 16,
      paddingLeft: 30,
    };
  };
  const textChange = () => {
    Setbookmarktext(!bookmarktext);
    console.log(bookmarktext);
  };
  const ChangeBookmark = () => {
    Settext((text = "Bookmarked"));
    BookmarkShift();
  };
  const ResetBookmark = () => {
    Settext((text = "Bookmark"));
    resetBookmark();
  };

  return (
    <ModalProvider>
      {modal === true ? Modal_input() : () => setModal(!modal)}
      <div className="App">
        <div className="title_bar">
          <img
            src="image-hero-desktop.jpg"
            alt="background"
            className="background"
          />
          <div className="crowdfunding">crowdfund</div>
          <div className="options">
            <div className="about">
              <a
                href="https://blog.hubspot.com/marketing/remarkable-about-us-page-examples"
                target="_blank"
              >
                About
              </a>
            </div>
            <div className="discover">
              <a href="https://themeforest.net/search/discover" target="_blank">
                Discover
              </a>
            </div>
            <div className="get_started">
              <a
                href="https://startbootstrap.com/themes/landing-pages"
                target="_blank"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
        <div className="logo">
          <img src="logo-mastercraft.svg" alt="Mastercraft_logo" />
        </div>
        <div className="main_container">
          <div className="title">Mastercraft Bamboo Monitor Riser </div>
          <div className="title_desc">
            A beautiful & handcrafted monitor stand to reduce neck and eye
            strain.
          </div>
          <button
            type="button"
            className="back_project_button"
            onClick={() => setModal(!modal)}
          >
            Back this project
          </button>
          <button
            className="bookmark"
            style={bookmark_styles}
            onClick={() => textChange()}
          >
            {text}
          </button>
          {bookmarktext === true ? ChangeBookmark() : null}
          {bookmarktext === false ? ResetBookmark() : null}
          {bookmarktext === true ? change_icon_styles() : null}
          <button className="bookmark2" onClick={() => textChange()} >
            <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg" className='bookmarkfill'>
              <g fill="none" fillRule="evenodd">
                <circle  cx="28"  cy="28" r="28" className='bookmark_cirlce' style={bookmark_icon_styles}/>
                <path fill="#B1B1B1" d="M23 19v18l5-5.058L33 37V19z" className='bookmark_middle'/>
              </g>
            </svg>
          </button>
          <div className="progess">
            <div className="money_made">
              <span style={{ fontSize: 32, fontWeight: 700 }}>${backed}</span>
              <br />
              <span style={{ color: "hsl(0, 0%, 48%)" }}>
                of $100,000 backed
              </span>
            </div>
            <div className="backers">
              <span style={{ fontSize: 32, fontWeight: 700 }}>{backers}</span>{" "}
              <br />
              <span style={{ color: "hsl(0, 0%, 48%)" }}>total backers</span>
            </div>
            <div className="days">
              <span style={{ fontSize: 32, fontWeight: 700 }}>
                56 <br />
              </span>
              <span style={{ color: "hsl(0, 0%, 48%)" }}>days left</span>
            </div>
          </div>
          <div className="proggressbar_container" style={{  width: 660}}>
            <input
              type="range"
              name="progress"
              id="progressbar"
              min="1"
              max="100"
              className="progressbar"
              value={backed / 1000}
            />
            <div className='progress' style={{width : backed/1000 * 7}}></div>
            <div className='progress_left'></div>
          </div>
          <div className="origin">
            <div className="origin_title">About this project </div>
            <div className="origin_desc1">
              The Mastercraft Bamboo Monitor Riser is a sturdy and stylish
              platform that elevates <br />
              your screen to a more comfortable viewing height. Placing your
              monitor at eye level has <br />
              the potential to improve your posture and make you more
              comfortable while at work, <br />
              helping you stay focused on the task at hand.
            </div>
            <div className="origin_desc2">
              Featuring artisan craftsmanship, the simplicity of design creates
              extra desk space below <br />
              your computer to allow notepads, pens, and USB sticks to be stored
              under the stand.
            </div>
          </div>
          <div className="types_container">
            <div className="bamboo">
              <div className="bamboo_title">Bamboo Stand</div>
              <div className="bamboo_price">Pledge $25 or more</div>
              <div className="bamboo_desc">
                You get an ergonomic stand made of natural bamboo. You've helped
                us launch <br />
                our promotional campaign, and you’ll be added to a special
                Backer member list.
              </div>
              <div className="bamboo_stock">
                <span style={{ fontWeight: 700, fontSize: 30 }}>101</span>
                <span
                  style={{
                    color: "hsl(0, 0%, 48%)",
                    position: "relative",
                    bottom: 5,
                    left: 3,
                  }}
                >
                  left
                </span>
              </div>
              <button
                type="button"
                className="bamboo_select"
                onClick={() => setModal(!modal)}
              >
                Select Reward
              </button>
            </div>
            <div className="black">
              <div className="black_title">Black Edition Stand</div>
              <div className="black_price">Pledge $75 or more</div>
              <div className="black_desc">
                You get a Black Special Edition computer stand and a personal
                thank you. You’ll <br />
                be added to our Backer member list. Shipping is included.
              </div>
              <div className="black_stock">
                <span style={{ fontWeight: 700, fontSize: 30 }}> 64 </span>
                <span
                  style={{
                    color: "hsl(0, 0%, 48%)",
                    position: "relative",
                    bottom: 5,
                    left: 3,
                  }}
                >
                  left
                </span>
              </div>
              <button
                type="button"
                className="black_select"
                onClick={() => setModal(!modal)}
              >
                Select Reward
              </button>
            </div>
            <div className="mahogany">
              <div className="mahogany_title">Mahogany Special Edition</div>
              <div className="mahogany_price">Pledge $200 or more</div>
              <div className="mahogany_desc">
                You get two Special Edition Mahogany stands, a Backer T-Shirt,
                and a personal <br />
                thank you. You’ll be added to our Backer member list. Shipping
                is included.
              </div>
              <div className="mahogany_stock">
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: 30,
                    color: "hsl(0, 0%, 50%)",
                  }}
                >
                  0
                </span>
                <span
                  style={{
                    color: "hsl(0, 0%, 82%)",
                    position: "relative",
                    bottom: 5,
                    left: 3,
                  }}
                >
                  {" "}
                  left
                </span>
              </div>
              <button type="button" disabled className="mahogany_select">
                Out of Stock
              </button>
            </div>
          </div>      
        </div>
      </div>
    </ModalProvider>
  );
}

export default App;
